import { AxiosResponse } from 'axios';
import axiosClient from './axios';
import { ApiError } from './errors';

const getListCompany = async ({ page = 1, limit = 10, sort = 'arc', search = '' }: { page: number; limit: number; sort: 'arc' | 'des'; search: string }) => {
  try {
    return axiosClient.get(`/v1/get/company${`?page=${page}&limit=${limit}&sort=${sort}`}&userRole=employer&search=${search}`);
  } catch (error) { }
};

const deleteCompany = async (companyCode: string) => {
  try {
    return await axiosClient.delete(`/v1/company/delete`, {
      data: {
        code: companyCode,
      }
    });
  } catch (error) {
    throw error;
  }
};

export interface RawApiCompanyDetail {
  _id: string;
  code: string;
  name: string;
  companyLocation?: string;
  companyIndustry?: string;
  phoneCode?: string | null;
  phone?: number | string | null;
  address?: string | null;
}

export interface RawApiCompany {
  _id?: string;
  code: string;
  fullname?: string;
  companyName?: string | null;
  companyCode?: string;
  email?: string;
  address?: string | null;
  company?: RawApiCompanyDetail;
}

interface GetListCompanyBody {
  data: RawApiCompany[];
  metadata: { recordTotal: number }[];
}

export interface GetListAllClientsParams {
  page?: number;
  limit?: number;
  sort?: 'arc' | 'des';
  search?: string;
  /** Assign-client pickers only — includes employer accounts seeded via
   *  assign-client that never verified their email. Keep the emailVerify
   *  gate as the default for any consumer that is not an assign flow. */
  skipEmailVerifyCheck?: boolean;
}

const getListAllClientsApi = async (params: GetListAllClientsParams = {}): Promise<AxiosResponse<GetListCompanyBody>> => {
  return axiosClient.get<GetListCompanyBody>('/v1/admin/account/listing-clients', {
    // backend paginates by recordPerPage, not limit
    params: { userRole: 'employer', ...params, recordPerPage: params.limit },
  });
};

export interface UpdateCompanyInfoParams {
  clientType: string;
  companyCode: string;
  name: string;
  companyLocation: string;
  registeredNumber: string;
  addressText: string;
  country: string;
}

export interface UpdatedCompanyInfo {
  _id: string;
  code: string;
  name: string;
  companyLocation?: string;
}

const updateCompanyInfoApi = async (params: UpdateCompanyInfoParams): Promise<UpdatedCompanyInfo> => {
  const response = await axiosClient.post('/v1/company/update', params);
  const company = response?.data?.company as UpdatedCompanyInfo | null;
  if (!company) throw new ApiError(0, 'Company update failed: no data returned');
  return company;
};

export {
  getListAllClientsApi,
  getListCompany,
  deleteCompany,
  updateCompanyInfoApi,
};
